import { Component, OnInit, EventEmitter, Output, Input, NgModule } from "@angular/core";
import { EditorComponent } from "../editor/editor.component";
import { ImageUploadModule } from "angular2-image-upload";
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { ITexttoCanvas, TexttoCanvasObj, ITextprops, TextpropsObj, IFont, FontObj } from "../models/jersey";
import { Jersey, Ifile, UniformStyle, sport, FileObj, gender, reversible } from '../admin/models/upload';
import { AlertService } from '../alert-component/alert.service';
import FontFaceObserver from 'fontfaceobserver';
import 'fabric';
import { strictEqual } from "assert";
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { Element } from "@angular/compiler";
import { AngularMultiSelect } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { ViewChild } from '@angular/core';
import * as firebase from 'firebase/app';
import { ToastrService } from 'ngx-toastr';
import $ from "jquery";
import CircleType from "circletype"
import { path } from "snapsvg";
import { async } from "q";
import { Ng5SliderModule, Options, LabelType } from 'ng5-slider';
import { element } from "protractor";
import { FONT_SIZE,INCH_SIZE_IN_PX,INCH_SIZE_IN_PX_For_NAME } from '../editor/font';
import { wrap } from "module";
// import  Jimp   from "jimp";
// import * as Jimp from 'jimp'

declare const fabric: any;
declare var Snap: any;
declare var mina: any;
@Component({
	selector: 'graphic-option',
	templateUrl: '../../app/graphicoption/graphicoption.component.html',
	styleUrls: ['../../app/graphicoption/graphicoption.component.css']
})
export class graphicoptionComponent {
	@Input('sendcanvas') sendcanvas: any;
	@Input('logo') logo: any;
	@Input('availableLogoLocations') availableLogoLocations: any;
	@Input('showMessageFlag') showMessageFlag: any;
	@Input('layerColorApplied_OutSide') layerColorApplied_OutSide: any;
	@Input('layerColorApplied_InSide') layerColorApplied_InSide: any;
	@Input('selected_slide') selected_slide: any;
	@Input('applied_OutSideOptions') applied_OutSideOptions: any;
	@Input('clipartList') clipartList: any;
	@Input('clipArtImage') clipArtImage: any;
	@Output() clipartListPosition: EventEmitter<ITexttoCanvas> = new EventEmitter();
	@Output() updateTeamName: EventEmitter<ITexttoCanvas> = new EventEmitter();
	@Output() updateTeamNameBelow: EventEmitter<ITexttoCanvas> = new EventEmitter();
	@Output() changelogo: EventEmitter<ITexttoCanvas> = new EventEmitter();

	@Output() updatelogo: EventEmitter<any> = new EventEmitter();
	@Output() updatelogoClipArt: EventEmitter<any> = new EventEmitter();
	@Output() handelLoading: EventEmitter<any> = new EventEmitter();
	@Output() openModal: EventEmitter<any> = new EventEmitter();



	@ViewChild(AngularMultiSelect, { static: false }) varietalDropdown: AngularMultiSelect;

	private url: string = '';
	private canvas: any;
	public logoUrl: any;
	public settings: any;
	public itemList: any;
	public is_show2: boolean = false;
	public is__team_stroke: boolean = false;
	public is__player_stroke: boolean = false;
	public is__numbers_stroke: boolean = false;
	public selectedItems: any;
	private availableColors = "#000000";
	private colorsList: any = [];
	private colorsListForStroke: any = [];
	logoFiles: any = [];
	private loading: boolean = false;
	circleType: any;
	circleType1: any;
	circleTypetye: any;
	circleType1type: any;
	categoryFlag: boolean = false;
	imgUrls:any;
	value1 :any = [];
	qtd:any=[] ;
	

	//variables to reset fields
	private selectColorCodeForTeamStroke = '#ffffff';
	private selectedColorForTeamStroke = '';
	private selectedColor1 = '';
	private curveTxt1 = '';
	private curveTxt2 = '';
	private selectColorCode1 = '';
	private selectedColor2 = '';
	private selectColorCode2 = '';
	private selectedColor = '';
	private selectColorCode = '';
	private selectedColorForPlayerStroke = '';
	private selectColorCodeForPlayerStroke = '#ffffff';
	private selectedColorForNumbersStroke = '';
	private selectColorCodeForNumbersStroke = '#ffffff';
	category: any;
	archSizes = [1, 2, 3, 4, 5];
	curveFlage: boolean = false;
	curveFlage1: boolean = false;
	check: boolean = false;
	chestLogo: boolean = false;

	curveFlageToInitiate: boolean = false;
	curveFlageToInitiateback: boolean = false;

	curveTitle = "add curve";
	curveTitleback = "add curve";

	logoSizeOptions: Options = {
		floor: 0,
		ceil: 100
	};
	logoAllOptions: Options = {
		floor: 0,
		ceil: 100
	};
	fontSizeTeamOptions: Options = {
		floor: 0,
		ceil: 50,
		showTicks: true,
		stepsArray:[{value:0},{value:10},{value:20},{value:30},{value:40},{value:50}]

	};
	fontSizePlayerOptions: Options = {
		floor: 0,
		ceil: 50,
		showTicks: true,
		stepsArray:[{value:0},{value:10},{value:20},{value:30},{value:40},{value:50}]
	};
	frontNumberSizeOptions: Options = {
		floor: 0,
		ceil: 100
	};
	backNumberSizeOptions: Options = {
		floor: 0,
		ceil: 100
	};
	heightLogo: number = 0;
	changeValue: number = 0;
	// logoAllLocation: number = 0;
	frontLogo: 'data:image/png;base64,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';

	private is_team_stroke;
	// Default logo Base64 code
	private defaultLogoBase64: string = `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`;
	private base64textString: any = this.defaultLogoBase64;
	private base65textString: any = this.defaultLogoBase64;
	enableBottomText: boolean = false;
	enablePlayerBottomText: boolean = false;

	public colorselected: any;
	public colorselected1: any;
	colorselectedTeamFontOutline :any;
	colorselectedTeamFontOutline1 :any;

	public colornameTeamselected: any;
	public colornamePlayerselected: any;
	public colornameFontOutlineselected: any;
	public colornameFontOutlineselected1: any;

	//for player number
	public colorselectedforPlayerNumber: any;
	colorselectedforPlayerNumberName :any;

	public colorselectedfontOutlinePlayerNumber: any;
	colorselectedfontOutlinePlayerNumberName :any;
	//please change this data structure to allow alternate display label for front end
	//I should access font label in front end with fontArray[i].label = College Block && fontArray[i].font = CollegeBlock2
	//implement this change for all places in this component where font is used
	//cannot show user ful_block-webfont as font type -> should display "FULL BLOCK", "College Block", etc.

	//------------- -(DISPLAY NAME, FONT NAME)------------------------------

	// private fontArray: IFont[] = [
	// 	new FontObj("", "CollegeBlock2-0"),
	// 	new FontObj("College Block", "CollegeBlock2-0"),
	// 	new FontObj("Dade", "dade-webfont"),
	// 	new FontObj("Full Block", "full_block-webfont"),
	// 	new FontObj("Golden Bear", "golden_bear-webfont"),
	// 	new FontObj("Horned Frogs", "horned_frogs-webfont"),
	// 	new FontObj("Huskies", "huskie-webfont"),
	// 	new FontObj("Knights", "kights-webfont"),
	// 	new FontObj("Lubbock", "lubbock-webfont")
	// 	// new FontObj("Pullman","pullman-webfont")
	// ];

	private fontArray: any;

	public hideLogoButtons: boolean = false;

	public buttonFrontChest: boolean = false;
	public buttonBackUpper: boolean = false;
	public buttonShortLeg: boolean = false;

	public team_Graphic: boolean = false;

	public text_TeamName_Image: string = "Use Logo Instead";
	public PlayerNameText: string = "Hide Player Name";

	public select_Team_background_color: string;
	public select_Player_background_color: string;
	public select_Number_background_color: string = "#010101";

	public select_Team_Font: string;
	public select_Player_Font: string;
	public select_number_Font: string = "CollegeBlock2-0";
	public select_number_FontStroke: string = "";
	public select_number_font_size: number = 85;
	public select_number_font_name: string = "30";

	public move_Rotate_TeamName: boolean = false;
	public move_Rotate_PlayerName: boolean = false;
	public move_Rotate_FrontNumber: boolean = false;
	public move_Rotate_BackNumber: boolean = false;

	private Team_Font_Size: number = 14; //Default Font Size used when no Jersey is loaded in Canvas.
	private Player_Font_Size: number = 14; //Actual Font Size of Jersey is fetched from Canvas and bind when loaded.

	private Team_Name: string = ""; //To bind Team Name and Player Name from SVG while loading
	private Team_Name_Below: string = ""; //To bind Team Name and Player Name from SVG while loading
	selectedField: any;
	selectedValue: any;
	private Player_Name: string = "";
	private Player_Name_Below: string = "";

	private Front_Number: string = ""; //To bind Team Name and Player Name from SVG while loading
	private Back_Number: string = ""; //To bind Team Name and Player Name from SVG while loading

	private Front_Number_var: number = 10 //For Front number Change with setpper

	private teamName: ITextprops = new TextpropsObj("Golden State", 14, "#ec6721", "golden_bear-webfont", "", 0, 0); //Declared for Movable Layer of Team Name and Player Name
	private teamNameBelow: ITextprops = new TextpropsObj("Golden State", 14, "#ec6721", "golden_bear-webfont", "", 0, 0); //Declared for Movable Layer of Team Name and Player Name

	private playerName: ITextprops = new TextpropsObj("Golden State", 14, "#ec6721", "golden_bear-webfont", "", 0, 0);
	private playerNameBelow: ITextprops = new TextpropsObj("Golden State", 14, "#ec6721", "golden_bear-webfont", "", 0, 0);

	private frontNumber: ITextprops = new TextpropsObj("30", 85, "#010101", "CollegeBlock2-0", "", 0, 0);
	private backNumber: ITextprops = new TextpropsObj("30", 85, "#010101", "CollegeBlock2-0", "", 0, 0);

	private noneColor = {
		colorCode: "",
		colorName: " None "
	}
	snapSvg: any;
	isExpaned: boolean;
	selectedTeamFont: string;
	selectedPlayerFont: string;
	selectedNumbersFont: string;
	isTeamNameSection: any;
	uploadedLogoPath: any;
	uploadedlogoName: any;
	uploadedlogoNameFront: any;

	// availableLogoLocations: any[];
	logoFile: any[];
	selectedLogo: any;
	selectedItem = [];
	dropdownSettings = {};
	fillColorsList: any = [];
	simpledropdownSettings: any = {};
	is_show: boolean;
	fontList: any;
	activeTeamFont: any[];
	selectedTeamFontName: string;
	value: number = 100;
	slidervalue1: number = 65;
	simpleOptions1: Options = {
		floor: 10,
		ceil: 80,
		translate: (value: number, label: LabelType): string => {
			switch (label) {
			  case LabelType.Floor:
				return 'More Arc';
			  case LabelType.Ceil:
				return 'Less Arc' ;
			default:
			return '' ;
			// + this.slidervalue1
			}
		}
	};
	slidervalue2: number = 65;
	simpleOptions2: Options = {
		floor: 10,
		ceil: 80,
		translate: (value: number, label: LabelType): string => {
			switch (label) {
			  case LabelType.Floor:
				return 'More Arc';
			  case LabelType.Ceil:
				return 'Less Arc' ;
			default:
			return '';
			// + this.slidervalue2
			}
		}
	};
	showSlide1: boolean = false;
	showFontOutLine: boolean = false;
	showFontOutLine1: boolean = false;
	showFontOutLineForPlayerNum: boolean = false;
	fontOutline =  'No';
	fontOutline1 =  'No';
	fontOutlineForPlayerNum =  'No';
	fontStyle = 'Straight Text';
	fontStyle1 = 'Straight Text';
	showSlide2: boolean = false;
	fontSizee :any;
	frontSize2 : any;
	frontSize3 : any;
	backSize1:any;
	backSize2:any;
	
	teamName1:any;
	teamName2:any;

	playerName1:any;
	playerName2:any;

	constructor(


		private toastr: ToastrService,
		private af: AngularFireDatabase,
		private alertService: AlertService) {
		af.list('/colors').valueChanges().subscribe(colors => {
			this.colorsList = colors;
			for (var i = 0; i < colors.length; i++) {
				this.colorsListForStroke.push(colors[i]);
				this.colorsList[i].itemName = this.colorsList[i].colorName;
				this.colorsList[i].id = i + 1;
				if (this.colorsList[i].colorName && this.colorsList[i].colorName != "") {
					this.fillColorsList.push(this.colorsList[i]);
				}
			}
			this.colorsListForStroke.unshift(this.noneColor);
		});
		this.getFont();
		localStorage.setItem('graphicspage', 'graphicspage');
	}

	getFont() {
		this.af.list('/fonts').snapshotChanges()
			.subscribe(data => {
				this.fontArray = [];
				data.forEach(action => {
					const value = action.payload.val();
					const $key = action.key;
					this.fontArray.push(value);
				});
				this.loadFonts();

			});
	}

	loadFonts() {
		var font;
		this.fontList = [];
		for (var i = 0; i < this.fontArray.length; i++) {
			font = new FontFaceObserver(this.fontArray[i]);
			font.load().then(function () {
			}).catch(function () { });
			try {
				if (this.fontArray[i].displayname && this.fontArray[i].displayname != "") {
					var f = {
						id: i,
						itemName: this.fontArray[i].displayname,
						fontname: this.fontArray[i].fontname
					};
					this.fontList.push(f);
				}
			} catch (error) {

			}

		}

	}

	ngOnInit() {
		this.category = localStorage.getItem('category');
		this.category = this.category.replace(/\s/g, "");
		this.fontSizee = FONT_SIZE[this.category];
		if(!this.fontSizee || this.fontSizee==undefined){
			this.fontSizee = FONT_SIZE['DeafultValues'];
		}
		this.frontSize2 = this.fontSizee.frontNumber;
		this.frontSize3 = INCH_SIZE_IN_PX[this.fontSizee.frontNumberSizes[1]];
        this.backSize1 =  INCH_SIZE_IN_PX[this.fontSizee.backNumberSizes[0]];
        this.backSize2 = this.fontSizee.backNumber;
		this.frontSize2 = INCH_SIZE_IN_PX[this.fontSizee.frontNumberSizes[0]];
		this.frontSize3 = INCH_SIZE_IN_PX[this.fontSizee.frontNumberSizes[1]];
        this.backSize1 =  INCH_SIZE_IN_PX[this.fontSizee.backNumberSizes[0]];
		this.backSize2 = INCH_SIZE_IN_PX[this.fontSizee.backNumberSizes[1]];
		
        // this.teamName1 = this.fontSizee.teamName;
		this.teamName1 = INCH_SIZE_IN_PX_For_NAME[this.fontSizee.frontTeamNameSizes[0]];
		this.teamName2 = INCH_SIZE_IN_PX_For_NAME[this.fontSizee.frontTeamNameSizes[1]];

		this.playerName1 = INCH_SIZE_IN_PX_For_NAME[this.fontSizee.frontPlayerNameSizes[0]];
		this.playerName2 = INCH_SIZE_IN_PX_For_NAME[this.fontSizee.frontPlayerNameSizes[1]];
		if (localStorage.getItem('emitcolor'))
			localStorage.removeItem('emitcolor')
		if (localStorage.getItem('category') == 'Football')
			this.categoryFlag = true;
		if (document.getElementById("Name-Below-Back"))
			document.getElementById("Name-Below-Back").remove();
		let queryAl = document.querySelectorAll('#Name-Front');
		let queryAl1 = document.querySelectorAll('#Name-Back');

		if (localStorage.getItem('curve'))
			localStorage.removeItem('curve');

		let setStyle = document.getElementById("Name-Back");
		if (setStyle && setStyle.style && setStyle.style.display == 'none') {
			setStyle.style.display = "none";
			this.PlayerNameText = "Show Player Name";
		} else {
			this.PlayerNameText = "Hide Player Name";
			if (setStyle && setStyle.style)
				setStyle.style.display = "";
		}

		if (document.getElementById('Chest-Logo')) {
			this.chestLogo = true;
		} else {
			this.chestLogo = false;
		}
		console.log("this.availableLogoLocations!!!!!!!",this.availableLogoLocations);
    for(i=0;i<this.availableLogoLocations.length;i++){
			this.qtd[i]= 30;
		}
		// check the canvas for what graphic options are present, only show options if the layer is available
		this.checkGraphicOptions();


		// let belowBack = document.getElementById("Name-Below-Back");
		if (this.showMessageFlag) setStyle.style.display == 'none';
		this.snapSvg = Snap("#svg");
		this.isTeamNameSection = true;
		if (document.getElementsByClassName("text-element").length > 0) {
			var object = {
				paths: document.getElementsByClassName("text-element")
			};
			if (object.paths) {
				for (var i = 0; i < object.paths.length; i++) {
					//Get  Team Name - Text properties from Canvas for binding with movable layer
					if (object.paths[i].id === "Name-Below-Front") {
						this.Team_Name_Below = document.getElementById('Name-Below-Front').textContent;
					}

					if (object.paths[i].id === "Name-Front") {
						this.teamName = new TextpropsObj(object.paths[i].innerHTML, (<any>object.paths[i]).style.fontSize, (<any>object.paths[i]).style.fill, (<any>object.paths[i]).style.fontFamily, (<any>object.paths[i]).style.stroke, (<any>object.paths[i]).style.top, (<any>object.paths[i]).style.left);
						this.Team_Font_Size = Math.floor((<any>object.paths[i]).style.fontSize);
						this.Team_Font_Size = Math.floor(<any>window.getComputedStyle(document.getElementById("Name-Front")).fontSize.split('px')[0]);
						let checkcurve = window.location.href.split('?curveFlag=')[1];
						let checkcurvearray;
						if (checkcurve)
							checkcurvearray = checkcurve.split('');

						if (checkcurvearray && checkcurvearray[0] == '1' && !localStorage.getItem('typed')) {
							this.Team_Name = document.getElementById('Name-Front').textContent;
							document.getElementById('Name-Front').innerHTML = this.Team_Name;
							this.curveTitle = 'remove curve';
							this.curveFlageToInitiate = false;
							this.curveFlage = true;
							this.showSlide1 = true;
							if (localStorage.getItem('slidervalue1')) {
								this.markItCurveFront(true);
							}
						} else {
							if (!localStorage.getItem('circleType')) {
								this.Team_Name = object.paths[i].innerHTML;
								this.curveTitle = 'add curve';
								this.curveFlageToInitiateback = true;
								this.curveFlage = false;
								// this.Team_Name_Below = document.getElementById('Name-Below-Back').textContent;
							} else {
								this.Team_Name = localStorage.getItem('teamname');
								if (!this.Team_Name) {
									this.Team_Name = document.getElementById('Name-Front').textContent;
								}
								//    this.Team_Name_Below = document.getElementById('Name-Below-Back').textContent;
								this.curveTitle = 'remove curve';
								this.curveFlageToInitiate = false;
								this.curveFlage = true;
								this.showSlide1 = true;
								if (localStorage.getItem('slidervalue1')) {
									this.markItCurveFront(true);
								}
							}
						}
					}
					//Get  Plyer Name - Text properties from Canvas for binding with movable layer
					// if (object.paths[i].id === "Name-Below-Back") {
					// 	this.Player_Name_Below = document.getElementById('Name-Below-Back').textContent;
					// }
					if (object.paths[i].id === "Name-Back") {
						this.playerName = new TextpropsObj(object.paths[i].innerHTML, (<any>object.paths[i]).style.fontSize, (<any>object.paths[i]).style.fill, (<any>object.paths[i]).style.fontFamily, (<any>object.paths[i]).style.stroke, (<any>object.paths[i]).style.top, (<any>object.paths[i]).style.left);
						// this.Player_Font_Size =Math.floor((<any>object.paths[i]).style.fontSize);
						this.Player_Font_Size = Math.floor(<any>window.getComputedStyle(document.getElementById("Name-Back")).fontSize.split('px')[0]);
						let checkcurve = window.location.href.split('?curveFlag=')[1];
						let checkcurvearray;
						if (checkcurve)
							checkcurvearray = checkcurve.split('');
						if (checkcurvearray && checkcurvearray[1] == '1' && !localStorage.getItem('typed2')) {
							this.Player_Name = document.getElementById('Name-Back').textContent;
							document.getElementById('Name-Back').innerHTML = this.Player_Name;
							this.curveTitleback = 'remove curve';
							this.showSlide2 = true;
							this.curveFlageToInitiateback = false;
							this.curveFlage1 = true;
							if (localStorage.getItem('slidervalue2')) {
								this.markItCurveBack(true);
							}
						} else {
							if (object.paths[i].innerHTML && object.paths[i].innerHTML !== "" && !localStorage.getItem('circleType1')) {
								this.Player_Name = object.paths[i].innerHTML;
								this.curveTitleback = 'add curve';
								this.curveFlageToInitiateback = true;
								this.curveFlage1 = false;
							} else {
								this.Player_Name = localStorage.getItem('playername');
								if (!this.Player_Name) {
									this.Player_Name = document.getElementById('Name-Back').textContent;
								}
								this.curveTitleback = 'remove curve';
								this.showSlide2 = true;
								this.curveFlageToInitiateback = false;
								this.curveFlage1 = true;
								if (localStorage.getItem('slidervalue2')) {
									this.markItCurveBack(true);
								}
							}
						}


					}
					if (object.paths[i].id === "Number-Front" || object.paths[i].id === "Front-Number-2") {

						this.frontNumber = new TextpropsObj(object.paths[i].innerHTML, (<any>object.paths[i]).style.fontSize, (<any>object.paths[i]).style.fill, (<any>object.paths[i]).style.fontFamily, (<any>object.paths[i]).style.stroke, (<any>object.paths[i]).style.top, (<any>object.paths[i]).style.left);
						this.select_number_font_size = Math.floor((<any>object.paths[i]).style.fontSize);
						if (object.paths[i].innerHTML && object.paths[i].innerHTML !== "") {
							this.select_number_font_name = object.paths[i].innerHTML;
							this.Front_Number = object.paths[i].innerHTML;
						}
					}
					if (object.paths[i].id === "Number-Back") {
						this.backNumber = new TextpropsObj(object.paths[i].innerHTML, (<any>object.paths[i]).style.fontSize, (<any>object.paths[i]).style.fill, (<any>object.paths[i]).style.fontFamily, (<any>object.paths[i]).style.stroke, (<any>object.paths[i]).style.top, (<any>object.paths[i]).style.left);
						this.select_number_font_size = Math.floor((<any>object.paths[i]).style.fontSize);
						if (object.paths[i].innerHTML && object.paths[i].innerHTML !== "") {
							this.select_number_font_name = object.paths[i].innerHTML;
							this.Back_Number = object.paths[i].innerHTML;
						}
					}
				}
			}
		}
		// this.availableLogoLocations = [];
		var loc = [];
		if (document.getElementsByTagName("image").length > 0) {
			var location = document.getElementsByTagName("image");
			if (location) {
				for (var i = 0; i < location.length; i++) {
					if (location[i].id) {
						var selected = false;
						try {
							var sel = document.getElementById(location[i].id).getAttribute('data');
							if (sel && sel != "") {
								selected = true;
							}
						} catch (error) {
						}
						var obj = {
							id: location[i].id,
							label: location[i].id.split("-").join(" ").split("_1_").join(" "),
							selected: selected
						};

						var index = this.availableLogoLocations.findIndex(function (d) {
							return d.id == location[i].id
						});
						if (index == -1) {
							// this.availableLogoLocations.push(obj);
							loc.push(obj);
							 console.log(obj);
						} else {
							obj.selected = this.availableLogoLocations[index].selected;
							loc.push(obj);
								console.log(obj);
						}
					}
				}
			}
		}
		if(loc.length!=0){
      this.availableLogoLocations = loc;
		}
		
		console.log("this.availableLogoLocations",this.availableLogoLocations);
		if (Array.isArray(this.availableLogoLocations)) {
			this.availableLogoLocations.forEach(d => {
				if (d.selected) {
					d.selected = false;
					this.addLogoOnLocation(d);
				} else {
					d.selected = true;
					this.addLogoOnLocation(d);
				}
			});
		}
    if(this.frontLogo==null || this.frontLogo==undefined){
			this.frontLogo = this.frontLogo
		}
		if (this.logo) {
			this.base64textString = this.logo;
			this.hideLogoButtons = true;
			this.base65textString = 'data:image/png;base64,' + this.base65textString;
		} else {
			this.base64textString = 'data:image/png;base64,' + this.base64textString;
			this.base65textString = 'data:image/png;base64,' + this.base65textString;
			
			this.hideLogoButtons = false;
		}
		if (this.selected_slide == 1) {
			this.setDefaultValue(this.layerColorApplied_OutSide, this.layerColorApplied_InSide);
		} else {
			this.setDefaultValue(this.layerColorApplied_InSide, this.layerColorApplied_OutSide);
		}

		this.selectedItem = [
			{ "id": 1, "itemName": "None" }
		];
		this.activeTeamFont = [{ "id": 1, "itemName": "College Block", "fontname": "CollegeBlock2-0" }];

		this.simpledropdownSettings = {
			singleSelection: true,
			text: "Select Color",
			// labelKey: "colorName",
			classes: "myclass custom-select-box"
		};

		this.dropdownSettings = {
			singleSelection: false,
			text: "Select Uniform Type",
			searchPlaceholderText: "Select Uniform Type",
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: false,
			showCheckbox: true,
			classes: "myclass multiselect"
		};
		// let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		// if (isSafari){
		// 	document.getElementById('Name-Back-p').style.position = "fixed";
		// 	document.getElementById('Name-Front-p').style.position = "fixed";
		// }
	}

	doesTemplateHaveTeamNameFlag = true;
	doesTemplateHavePlayerNameFlag = true;
	doesTemplateHavePlayerNumbersFlag = true;
	checkGraphicOptions() {
		this.doesTemplateHaveTeamNameFlag = this.doesTemplateHaveTeamName();
		this.doesTemplateHavePlayerNameFlag = this.doesTemplateHavePlayerName();
		this.doesTemplateHavePlayerNumbersFlag = this.doesTemplateHavePlayerNumbers();
	}

	ngAfterViewInit() {
	}

	onItemSelect(item: any, field: string, teamorplayer: string) {
		this.varietalDropdown.closeDropdown();
		if (field == 'Color') {
			this.selectColorCode = item.colorCode;
			this.onChangeTeamNameValues(item, 'Color', 'Team');
			this.is_show = !this.is_show;
		} else if (field == 'Fonttype') {
			this.onChangeTeamNameValues(item.fontname, 'Fonttype', 'Team')
		}

	}
	OnItemDeSelect(item: any) {
		// this.selectedItem.push(item);
		// this.varietalDropdown.closeDropdown();
	}
	onSelectAll(items: any) {
	}
	onDeSelectAll(items: any) {
	}

	setDefaultValue(data, altdata) {
		var object;
		if (data) {
			object = {
				paths: data
			};
		}
		var defaultFont = 'CollegeBlock2-0';
		var defaultColorObj = {
			"colorCode": "#2b2d2f",
			"colorName": "Charcoal Gray"
		};
		this.selectedTeamFontName = "College Block";

		if (object) {
			if (object.paths) {
				for (var i = 0; i < object.paths.length; i++) {
					if (object.paths[i].layer == "Name-Front") {
						this.selectedColor = object.paths[i].colorName;
						this.selectColorCode = object.paths[i].colorCode;
						this.selectedColorForTeamStroke = object.paths[i].fontStrokeColorName;
						this.selectedTeamFont = defaultFont;
						this.activeTeamFont = [{ "id": 1, "itemName": "College Block", "fontname": "CollegeBlock2-0" }];
						if (object.paths[i].fontType != "") {
							this.selectedTeamFont = object.paths[i].fontType;
							if (this.fontList) {
								this.activeTeamFont = this.fontList.filter(element => {
									return element.fontname == object.paths[i].fontType;
								});
							}
							if (this.activeTeamFont[0]) {
								this.selectedTeamFontName = this.activeTeamFont[0].itemName;
							}
						}
						// if (object.paths[i].fontStroke != "") {
						this.selectColorCodeForTeamStroke = object.paths[i].fontStroke;
						// }
						var cobj = {
							"colorCode": this.selectColorCode,
							"colorName": this.selectedColor
						};
						if (this.selectColorCode == "") {
							cobj = defaultColorObj;
						}
						var fobj = {
							"colorCode": this.selectColorCodeForTeamStroke,
							"colorName": this.selectedColorForTeamStroke
						};
						this.onChangeTeamNameValues(cobj, 'Color', 'Team');
						this.onChangeTeamNameValues(this.selectedTeamFont, 'Fonttype', 'Team');
						// if (object.paths[i].fontStroke != "") {
						this.onChangeTeamNameValues(fobj, 'FontStroke', 'Team');
						// }
						if (object.paths[i].text && object.paths[i].text != "") {
							this.onChangeTeamNameValues(object.paths[i].text, 'Name', 'Team');
						}
					}
					if (object.paths[i].layer == "Name-Back") {
						this.selectedColor1 = object.paths[i].colorName;
						this.selectColorCode1 = object.paths[i].colorCode;
						this.selectedColorForPlayerStroke = object.paths[i].fontStrokeColorName;
						// this.selectedPlayerFont = object.paths[i].fontType;
						this.selectedPlayerFont = defaultFont;
						if (object.paths[i].fontType != "") {
							this.selectedPlayerFont = object.paths[i].fontType;
						}
						// if (object.paths[i].fontStroke != "") {
						this.selectColorCodeForPlayerStroke = object.paths[i].fontStroke;
						// }
						var cobj = {
							"colorCode": this.selectColorCode1,
							"colorName": this.selectedColor1
						};
						if (this.selectColorCode1 == "") {
							cobj = defaultColorObj;
						}
						var fobj = {
							"colorCode": this.selectColorCodeForPlayerStroke,
							"colorName": this.selectedColorForPlayerStroke
						};
						this.onChangeTeamNameValues(cobj, 'Color', 'Player');
						this.onChangeTeamNameValues(this.selectedPlayerFont, 'Fonttype', 'Player');
						// if (object.paths[i].fontStroke != "") {
						this.onChangeTeamNameValues(fobj, 'FontStroke', 'Player');
						// }
						if (object.paths[i].text && object.paths[i].text != "") {
							this.onChangeTeamNameValues(object.paths[i].text, 'Name', 'Player');
						}
					}
					if (object.paths[i].layer == "Number-Front" || object.paths[i].layer == "Number-Back" || object.paths[i].layer === "Front-Number-2") {
						this.selectedColor2 = object.paths[i].colorName;
						this.selectColorCode2 = object.paths[i].colorCode;
						this.selectedColorForNumbersStroke = object.paths[i].fontStrokeColorName;
						// this.selectedNumbersFont = object.paths[i].fontType;
						this.selectedNumbersFont = defaultFont;
						if (object.paths[i].fontType != "") {
							this.selectedNumbersFont = object.paths[i].fontType;
						}
						if (object.paths[i].fontStroke != "") {
							this.selectColorCodeForNumbersStroke = object.paths[i].fontStroke;
						}
						var cobj = {
							"colorCode": this.selectColorCode2,
							"colorName": this.selectedColor2
						};
						if (this.selectColorCode2 == "") {
							cobj = defaultColorObj;
						}
						var arr = this.applied_OutSideOptions.filter(function (d) {
							return d.layer === object.paths[i].layer;
						});
						if (this.selectedNumbersFont == 'CollegeBlock2-0') {
							if (arr[0]) {
								this.selectedNumbersFont = arr[0].fontType;
								object.paths[i].fontType = arr[0].fontType;
							}
						}
						var fobj = {
							"colorCode": this.selectColorCodeForNumbersStroke,
							"colorName": this.selectedColorForNumbersStroke
						};
						this.onChangeTeamNameValues(cobj, 'Color', 'Numbers');
						this.onChangeTeamNameValues(this.selectedNumbersFont, 'Fonttype', 'Numbers');
						if (object.paths[i].fontStroke != "") {
							this.onChangeTeamNameValues(fobj, 'FontStroke', 'Numbers');
						}
						if (object.paths[i].layer == "Number-Front" || object.paths[i].layer=='Front-Number-2') {
							this.onChangeTeamNameValues(object.paths[i].fontSize, 'Fontsize', 'FrontNumber');
							if (object.paths[i].text && object.paths[i].text != "") {
								this.onChangeTeamNameValues(object.paths[i].text, 'Name', 'FrontNumber');
							}
						} else {
							this.onChangeTeamNameValues(object.paths[i].fontSize, 'Fontsize', 'BackNumber');
							if (object.paths[i].text && object.paths[i].text != "") {
								this.onChangeTeamNameValues(object.paths[i].text, 'Name', 'BackNumber');
							}
						}
					}
				}
			}
		}

		setTimeout(() => {
			let all = <any>document.querySelectorAll('*[id^="Pattern-Home-"]');
			for (let item of all) {
				document.getElementById(item.id.split('Pattern-Home-')[1]).style.fill = `url(#${item.id}`;
			}

			let all1 = <any>document.querySelectorAll('*[id^="Pattern-Away-"]');
			for (let item of all1) {
				document.getElementById(item.id.split('Pattern-Away-')[1]).style.fill = `url(#${item.id}`;
			}
			let allGrad = <any>document.querySelectorAll('*[id^="Gradient-Home-"]');
			for (let item of allGrad) {
				document.getElementById(item.id.split('Gradient-Home-')[1]).style.fill = `url(#${item.id}`;
			}

			let all1Grad = <any>document.querySelectorAll('*[id^="Gradient-Away-"]');
			for (let item of all1Grad) {
				document.getElementById(item.id.split('Gradient-Away-')[1]).style.fill = `url(#${item.id}`;
			}


		}, 0)

	}

	setDefaultValues() {
		var object;
		if (this.sendcanvas) {
			object = {
				paths: document.getElementsByTagName("path")
			};
		}
		if (object) {
			if (object.paths) {
				for (var i = 0; i < object.paths.length; i++) {
					if (object.paths[i].id == "Name-Front") {
						this.selectedColor = object.paths[i].colorName;
						this.selectColorCode = object.paths[i].fill == "rgb(0,0,0)" ? '' : object.paths[i].fill;
						this.selectedColorForTeamStroke = object.paths[i].fontStrokeColorName;
						this.selectColorCodeForTeamStroke = object.paths[i].stroke;
					}
					if (object.paths[i].id == "Name-Back") {
						this.selectedColor1 = object.paths[i].colorName;
						this.selectColorCode1 = object.paths[i].fill == "rgb(0,0,0)" ? '' : object.paths[i].fill;
						this.selectedColorForPlayerStroke = object.paths[i].fontStrokeColorName;
						this.selectColorCodeForPlayerStroke = object.paths[i].stroke;
					}
					if (object.paths[i].id == "Number-Front" || object.paths[i].id=='Front-Number-2') {
						this.selectedColor2 = object.paths[i].colorName;
						this.selectColorCode2 = object.paths[i].fill == "rgb(0,0,0)" ? '' : object.paths[i].fill;
						this.selectedColorForNumbersStroke = object.paths[i].fontStrokeColorName;
						this.selectColorCodeForNumbersStroke = object.paths[i].stroke;
					}
					if (object.paths[i].id == "Number-Back") {
						this.selectedColor2 = object.paths[i].colorName;
						this.selectColorCode2 = object.paths[i].fill == "rgb(0,0,0)" ? '' : object.paths[i].fill;
						this.selectedColorForNumbersStroke = object.paths[i].fontStrokeColorName;
						this.selectColorCodeForNumbersStroke = object.paths[i].stroke;
					}
				}
			}
		}
	}

	makePlayerNameHide(){
		document.getElementById("Name-Back").style.display = "none";
	}
	makePlayerNameVisible(){
		document.getElementById("Name-Back").style.display = "";
	}

	makeTeamNameHide(){
		document.getElementById("Name-Front").style.display = "none";
	}
	makeTeamNameVisible(){
		document.getElementById("Name-Front").style.display = "";
	}



	//toggle Player Name 
	togglePlayername() {
		if (this.PlayerNameText == "Hide Player Name") {
			this.PlayerNameText = "Show Player Name"
			document.getElementById("Name-Back").style.display = "none";
			this.showSlide2 = false;
		} else if (this.PlayerNameText == "Show Player Name") {
			this.PlayerNameText = "Hide Player Name";
			document.getElementById("Name-Back").style.display = "";
			if (this.curveFlag1)
				this.showSlide2 = true;


		}
		localStorage.setItem('typed2', 'typed2');
	}
	//Toggle Team Name and Graphic on Click
	teamName_Graphic(fileInput, frontLogo) {
		if (!this.team_Graphic) {
			this.text_TeamName_Image = "Use Text Instead";
			this.team_Graphic = true;
			fileInput.click();
		} else {
			this.text_TeamName_Image = "Use Logo Instead";
			this.team_Graphic = false;
			this.removeLogo(null,frontLogo);
		}

		// var object = this.sendcanvas._objects[0];
		var object = {
			paths: document.getElementsByTagName("path")
		};

		if (object.paths) {
			for (var i = 0; i < object.paths.length; i++) {
				if (object.paths[i].id === "Name-Front") {
					if (this.team_Graphic) {
						this.updateTeamName.emit(new TexttoCanvasObj("Team", "Name", ""));
						break;
					} else {
						this.updateTeamName.emit(new TexttoCanvasObj("Team", "Name", this.teamName.Name));
						break;
					}
				}
			}
		}
	}

	// addLogoOnLocation
	addLogoOnLocation(location) {
    console.log("location",location); 
		// var imageurl= 'data:image/png;base64,'+this.base64textString;    
		var imageurl = this.base64textString;
		this.imgUrls = this.base64textString;
		if (this.base64textString.startsWith('data:image/')) { } else {
			imageurl = 'data:image/png;base64,' + this.base64textString;
		}
		if (this.logo) {
			imageurl = this.base64textString;
			if (this.logo.startsWith('http') || this.logo.startsWith('data:image/')) {
				imageurl = this.logo;
			} else {
				imageurl = 'data:image/png;base64,' + this.base64textString;
			}
		}
		
		

		
		let self = this;
		location.selected = !location.selected;
		try {
			if (location.selected) {
				if (location.id == 'Right-Leg-Side-Logo') {
					this.rotateImage(imageurl, location.id)
				} else {
					if(document.getElementById(location.id).getAttribute("name")=='filpImage'){
            this.rotateImage(imageurl, location.id);
					}else{
            this.toDataURL(imageurl, function(dataUrl) {
							console.log(location);
							console.log(dataUrl);
							document.getElementById(location.id).style.display = '';
								document.getElementById(location.id).setAttribute("data",dataUrl);
						});
					
					}
				
				}
			} else {
				if (!location.id.includes('-Shadows') && location.id!='_x33_D_Soccer_Jersey_Layout')
				if(location.id!="Bat-Image"){
					document.getElementById(location.id).setAttribute("data", "");
				}	
			}
		} catch (error) {
		}
		// this.updatelogo.emit({ 'availableLogoLocations': this.availableLogoLocations });
		setTimeout(() => this.updatelogo.emit({ 'availableLogoLocations': this.availableLogoLocations }), 0);
	}

	toDataURL(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.onload = function() {
			var reader = new FileReader();
			reader.onloadend = function() {
				callback(reader.result);
			}
			reader.readAsDataURL(xhr.response);
		};
		xhr.open('GET', url);
		xhr.responseType = 'blob';
		xhr.send();
	}

	async rotateImage(imageurl, locationId) {
		let Jimp = require('jimp');
		const image = await Jimp.read(imageurl, (err, profile) => {
			let mimeType = profile.getMIME();
			let pa = profile.flip(true, false).getBase64(mimeType, (mimeType, getBase64) => {
				document.getElementById(locationId).setAttribute("data", getBase64);
				setTimeout(() => this.updatelogo.emit({ 'availableLogoLocations': this.availableLogoLocations }), 0);

			});
		});
	}

	

	async rotateImages(location) {
		var rotateImg= document.getElementById(location.id).getAttribute("data");
		if(rotateImg && rotateImg!=this.imgUrls){
			if(document.getElementById(location.id).getAttribute("name")=='filpImage'){
				document.getElementById(location.id).setAttribute("name", 'filpImage1');
				this.rotateImage(rotateImg, location.id);
			}else{
				document.getElementById(location.id).setAttribute("data", this.imgUrls);
			}
			
		}else{
		document.getElementById(location.id).setAttribute("name", 'filpImage');
		let Jimp = require('jimp');
		const image = await Jimp.read(this.imgUrls, (err, profile) => {
			let mimeType = profile.getMIME();
			let pa = profile.flip(true, false).getBase64(mimeType, (mimeType, getBase64) => {
				document.getElementById(location.id).setAttribute("data", getBase64);
				setTimeout(() => this.updatelogo.emit({ 'availableLogoLocations': this.availableLogoLocations }), 0);
			});
		});
		}
		
	}

	

	//Add Graphic on Team Name Location
	addLogoatTeamName() {
		var imageurl = this.base64textString;
		if (this.base64textString.startsWith('data:image/')) { } else {
			imageurl = 'data:image/png;base64,' + this.base64textString;
		}
		if (this.logo) {
			imageurl = this.base64textString;
		}
		let self = this;
		const snapSvgElement = Snap("#svg");
		fabric.Image.fromURL(imageurl, function (myImg) {
			const g = snapSvgElement.g();
			g.node.id = "frontImage";
			// var teamLogo = myImg.set({left: 100, top: 100 ,width:50,height:50});
			var tux = Snap.load("https://kenoleon.github.io/Front-End-Web-Dev-UI-UX/assets/images/simplePoly.svg", function (loadedFragment) {
				loadedFragment.select("#mrCube").node.style.display = "none";
				snapSvgElement.append(loadedFragment);
				loadedFragment.paper.select("#frontImage").g().image(imageurl, 180, 230, 100, 50).attr({
					style: 'cursor: move;'
				}).drag();
			});
			// self.sendcanvas.renderAll();
			// self.sendcanvas.add(teamLogo);
		});
	}

	//Add Graphic on Front Chest
	addLogoOnFrontChest() {
		this.buttonFrontChest = !this.buttonFrontChest;
		var imageurl = this.base64textString;
		if (this.base64textString.startsWith('data:image/')) { } else {
			imageurl = 'data:image/png;base64,' + this.base64textString;
		}
		// var imageurl= 'data:image/png;base64,'+this.base64textString;    
		if (this.logo) {
			imageurl = this.base64textString;
		}
		let self = this;
		const snapSvgElement = Snap("#svg");
		fabric.Image.fromURL(imageurl, function (myImg) {

			var img1 = myImg.set({
				left: 80,
				id: "frontImage",
				top: 220,
				width: 100,
				height: 50
			});
			const g = snapSvgElement.g();
			g.node.id = "frontImage";
			if (self.buttonFrontChest) {
				var tux = Snap.load("https://kenoleon.github.io/Front-End-Web-Dev-UI-UX/assets/images/simplePoly.svg", function (loadedFragment) {
					loadedFragment.select("#mrCube").node.style.display = "none";
					// loadedFragment.g().image(imageurl, 0,0, 100, 50);
					snapSvgElement.append(loadedFragment);
					loadedFragment.paper.select("#frontImage").g().image(imageurl, 180, 230, 100, 50).attr({
						style: 'cursor: move;'
					}).drag();
				});

				// var logoimage = g.image(imageurl, 180,230, 100, 50);
				// logoimage.attr({ style: 'cursor: move;' }).drag();
				// self.sendcanvas.add(img1).renderAll().setActiveObject(img1);
				self.onChangeTeamNameValues('add', 'frontImage', 'Image');
			} else {
				snapSvgElement.selectAll('#frontImage').remove();
				// self.sendcanvas.remove(self.getItemById("frontImage")).renderAll();
				self.onChangeTeamNameValues('add', 'frontImage', 'Image');
			}
		});

	}

	//Add Graphic on Back Side
	addLogoOnBackUpper() {
		this.buttonBackUpper = !this.buttonBackUpper;
		// var imageurl= 'data:image/png;base64,'+this.base64textString;
		var imageurl = this.base64textString;
		if (this.base64textString.startsWith('data:image/')) { } else {
			imageurl = 'data:image/png;base64,' + this.base64textString;
		}
		if (this.logo) {
			imageurl = this.base64textString;
		}
		let self = this;
		const snapSvgElement = Snap("#svg");
		fabric.Image.fromURL(imageurl, function (myImg) {
			//i create an extra var for to change some image properties
			var img2 = myImg.set({
				left: 470,
				id: "backImage",
				top: 200,
				width: 100,
				height: 100
			});
			const g = snapSvgElement.g();
			g.node.id = "backImage";
			if (self.buttonBackUpper) {
				var logoimage = g.image(imageurl, '70%', 230, 100, 50);
				logoimage.attr({
					style: 'cursor: move;'
				}).drag();
				// self.sendcanvas.add(img2).renderAll().setActiveObject(img2);
				self.onChangeTeamNameValues('add', 'backImage', 'Image');
			} else {
				snapSvgElement.selectAll('#backImage').remove();
				// self.sendcanvas.remove(self.getItemById("backImage")).renderAll();
				self.onChangeTeamNameValues('remove', 'backImage', 'Image');
			}
		});
	}

	addLogoOnShortLeg() {
		this.buttonShortLeg = !this.buttonShortLeg;
		// var imageurl= 'data:image/png;base64,'+this.base64textString;  
		var imageurl = this.base64textString;
		if (this.base64textString.startsWith('data:image/')) { } else {
			imageurl = 'data:image/png;base64,' + this.base64textString;
		}
		if (this.logo) {
			imageurl = this.base64textString;
		}
		let self = this;
		const snapSvgElement = Snap("#svg");
		fabric.Image.fromURL(imageurl, function (myImg) {
			//i create an extra var for to change some image properties
			var img3 = myImg.set({
				left: 270,
				id: "shortLegImage",
				top: 350,
				width: 50,
				height: 50
			});
			const g = snapSvgElement.g();
			g.node.id = "shortLegImage";
			if (self.buttonShortLeg) {
				var logoimage = g.image(imageurl, '40%', '65%', 80, 50);
				logoimage.attr({
					style: 'cursor: move;'
				}).drag();
				// self.sendcanvas.add(img3).renderAll().setActiveObject(img3);
				self.onChangeTeamNameValues('add', 'shortLegImage', 'Image');
			} else {
				snapSvgElement.selectAll('#shortLegImage').remove();
				// self.sendcanvas.remove(self.getItemById("shortLegImage")).renderAll();
				self.onChangeTeamNameValues('remove', 'shortLegImage', 'Image');
			}
		});
	}

	doesTemplateHaveTeamName() {
		let a = document.getElementById('Name-Front')
		if (a == null)
			return false;
		return true;
	}

	doesTemplateHavePlayerName() {
		let a = document.getElementById('Name-Back')
		if (a == null)
			return false;
		return true;
	}

	doesTemplateHavePlayerNumbers() {
		let a = document.getElementById('Number-Front')
		let b = document.getElementById('Number-Back')
		let c = document.getElementById('Front-Number-2')
		if (a == null && b == null && c == null) {
			console.log("here");
			return false;
		}
		console.log("TRUE")
		return true;
	}

	randomId() {
		return Math.floor(Math.random() * 999999) + 1;
	}

	selectItemAfterAdded(obj) {
		this.sendcanvas.deactivateAllWithDispatch().renderAll();
		this.sendcanvas.setActiveObject(obj);
	}

	onUploadFinished(file) {
	}

	onUploadStateChanged(state: boolean) {
	}

	//File Select & Upload
	uploadImage(event, clipArt, frontLogo) {
		this.removeLogo(clipArt, frontLogo);
		if (event.target.files.length != 0) {
			this.logoFile = [];
			this.logoFiles = [];
			let file = event.target.files[0];
			this.selectedLogo = event.target.files;
			this.logoFile.push({
				file: event.target.files,
				LayoutView: 'logo'
			});
			// var reader = new FileReader();
			// reader.onload = this.handleReaderLoaded.bind(this);
			// reader.readAsBinaryString(file);
			this.handleReaderLoaded(file, clipArt, frontLogo)
			this.hideLogoButtons = true;

			try {
				if (clipArt == 'clipArt')
					var cFile = this.logoFile[0].file[0];
				else
					var cFile = this.logoFile[0].file.item(0);
				var lFile = this.logoFile[0].LayoutView;
				let item1: Ifile = new FileObj('GameDay', 'logo', lFile, cFile);
				this.logoFiles.push(item1);
				this.changelogo.emit(this.logoFiles);
			} catch (error) {
				console.log(error);
			}

		}

	}


	async	handleReaderLoaded(file, frontLogo, frontLogo1) {
		this.toastr.warning("Plase wait while uploading logo", '', { onActivateTick: true, timeOut: 10000, positionClass: 'toast-top-right' });
		this.handelLoading.emit({ 'flag': true });
		let storageRef = firebase.storage().ref();
		let uniqlogo = 'uploadedlogo' + (new Date().getTime());
		if (frontLogo == 'frontLogo' || frontLogo1 == 'frontLogo') {
			this.uploadedlogoNameFront = uniqlogo;

		} else {
			this.uploadedlogoName = uniqlogo;
		}
		const fileData = await storageRef.child(`${'/uploaded-logos'}/${uniqlogo}`).put(file)
			.then(snapshot => {
				return snapshot.ref.getDownloadURL();
			}).then(async (downloadURL) => {
				if (frontLogo == 'frontLogo' || frontLogo1 == 'frontLogo') {
					this.frontLogo = downloadURL;

				} else {
					this.uploadedLogoPath = downloadURL;
					this.base64textString = downloadURL;

				}
				this.toastr.success('Logo sucessfully uploaded', '', { positionClass: 'toast-top-right' });
				this.loading = false;
				this.handelLoading.emit({ 'flag': false });
				this.updatelogo.emit({ 'logo': downloadURL });
				if (this.team_Graphic)
					this.addLogoatTeamName();

			}).catch(error => {
				this.base64textString = 'data:image/png;base64,' + this.defaultLogoBase64;
				if (frontLogo == 'frontLogo' || frontLogo1 == 'frontLogo') {
					this.frontLogo = undefined;

				} else {
					this.uploadedLogoPath = undefined;

				}
				this.handelLoading.emit({ 'flag': false });
				this.toastr.error("Faild to upload logo. Plase try again", '', { positionClass: 'toast-top-right', onActivateTick: true, timeOut: 10000 });
			});


	}

	getItemById(id) {
		var object = null,
			// objects = this.sendcanvas.getObjects();
			objects = document.getElementsByTagName("path");
		for (var i = 0, len = objects.length; i < len; i++) {
			if (objects[i].id && objects[i].id === id) {
				object = objects[i];
				break;
			}
		}
		return object;
	}
	getObjectById(id) {
		var resObject = null;
		// var object = this.sendcanvas._objects[0];
		var object = {
			paths: document.getElementsByTagName("path")
		};
		if (object.paths) {
			for (var i = 0; i < object.paths.length; i++) {
				if (object.paths[i].id && object.paths[i].id === id) {
					resObject = object.paths[i];
					break;
				}
			}
		}
		return resObject;
	}

	// Add Team Name Text and Delete if already Added in Canvas on Button Click - frontUpperChest
	rotate_TeamName_PlayerName(teamorplayer: string) {
		if (teamorplayer === "Team" && !this.move_Rotate_TeamName) {
			this.move_Rotate_TeamName = true;
		} else if (teamorplayer === "Player" && !this.move_Rotate_PlayerName) {
			this.move_Rotate_PlayerName = true;
		} else if ((teamorplayer === "Number" || teamorplayer === "FrontNumber") && !this.move_Rotate_FrontNumber) {
			this.move_Rotate_FrontNumber = true;
		} else if ((teamorplayer === "Number" || teamorplayer === "BackNumber") && !this.move_Rotate_BackNumber) {
			this.move_Rotate_BackNumber = true;
		}
	}


	//Make Team Name Movable and able to Rotate
	make_TeamName_Movable() {
		if (!this.move_Rotate_TeamName) {
			var object = this.getItemById('Name-Front');
			if (object == null) {
				var object = this.getObjectById('Name-Front')
				var text_Team = new fabric.Text(object.text, {
					fontSize: object.fontSize,
					fontFamily: object.fontFamily,
					left: object.left,
					top: object.top + 107,
					angle: 0,
					padding: 10,
					stroke: object.stroke,
					strokeWidth: .7,
					id: 'Name-Front',
					cornersize: 10,
					hasRotatingPoint: true
				});
				text_Team.set({
					fill: object.fill
				});
				this.onChangeTeamNameValues('', 'Name', 'Team');
				text_Team.setControlsVisibility({
					mt: false,
					mb: false,
					ml: false,
					mr: false,
					bl: false,
					br: false,
					tl: false,
					tr: false,
					mtr: false,
				});
				this.sendcanvas.add(text_Team);
				this.selectItemAfterAdded(text_Team);
			} else {
				this.selectItemAfterAdded(object);
			}
		}

	}


	// Add movable text to upper back of Jersey
	make_PlayerName_Movable() {
		if (!this.move_Rotate_PlayerName) {
			var object = this.getItemById('Name-Back');
			if (object == null) {
				var object = this.getObjectById('Name-Back')
				var text_player = new fabric.Text(object.text, {
					fontSize: object.fontSize,
					fontFamily: object.fontFamily,
					stroke: object.stroke,
					strokeWidth: .7,
					left: object.left + 410,
					top: object.top + 70,
					angle: 0,
					padding: 10,
					id: 'Name-Back',
					cornersize: 10,
					hasRotatingPoint: true
				});
				text_player.set({
					fill: object.fill
				});
				this.onChangeTeamNameValues('', 'Name', 'Player');
				text_player.setControlsVisibility({
					mt: false,
					mb: false,
					ml: false,
					mr: false,
					bl: false,
					br: false,
					tl: false,
					tr: false,
					mtr: false,
				});
				this.sendcanvas.add(text_player);
				this.selectItemAfterAdded(text_player);
			} else {
				this.selectItemAfterAdded(object);
			}
		}
	}

	make_FrontNumber_Movable() {
		if (!this.move_Rotate_FrontNumber) {
			var object = this.getItemById('Number-Front');

			if (object == null) {
				var object = this.getObjectById('Number-Front');
				var text_front_number = new fabric.Text(object.text, {
					fontSize: object.fontSize,
					fontFamily: object.fontFamily,
					stroke: object.stroke,
					left: object.left + 70,
					top: object.top + 150,
					strokeWidth: 2,
					angle: 0,
					padding: 10,
					id: 'Number-Front',
					cornersize: 10,
					hasRotatingPoint: true
				});
				text_front_number.set({
					fill: object.fill
				});
				this.onChangeTeamNameValues('', 'Text', 'FrontNumber');
				text_front_number.setControlsVisibility({
					mt: false,
					mb: false,
					ml: false,
					mr: false,
					bl: false,
					br: false,
					tl: false,
					tr: false,
					mtr: false,
				});
				this.sendcanvas.add(text_front_number);
				this.selectItemAfterAdded(text_front_number);
			} else {
				this.selectItemAfterAdded(object);
			}
		}
	}

	

	make_BackNumber_Movable() {
		if (!this.move_Rotate_BackNumber) {
			var object = this.getItemById('Number-Back');
			if (object == null) {
				var object = this.getObjectById('Number-Back');
				var text_back_number = new fabric.Text(object.text, {
					fontSize: object.fontSize,
					fontFamily: object.fontFamily,
					stroke: object.stroke,
					strokeWidth: 2,
					left: object.left + 460,
					top: object.top + 150,
					angle: 0,
					padding: 10,
					id: 'Number-Back',
					cornersize: 10,
					hasRotatingPoint: true
				});
				text_back_number.set({
					fill: object.fill
				});
				this.onChangeTeamNameValues('', 'Text', 'BackNumber');
				text_back_number.setControlsVisibility({
					mt: false,
					mb: false,
					ml: false,
					mr: false,
					bl: false,
					br: false,
					tl: false,
					tr: false,
					mtr: false,
				});
				this.sendcanvas.add(text_back_number);
				this.selectItemAfterAdded(text_back_number);
			} else {
				this.selectItemAfterAdded(object);
			}
		}
	}

	// Remove all text editor
	removeLogo(frontLogo, frontLogo1) {
		if (!this.sendcanvas) {
			if (frontLogo == 'frontLogo' || frontLogo1 == 'frontLogo') {
				this.frontLogo = undefined;
				
			} else {
				
				this.base64textString = 'data:image/png;base64,' + this.defaultLogoBase64;
				this.hideLogoButtons = false;
			}
			
			const snapSvgElement = Snap("#svg");
			// snapSvgElement.selectAll('#shortLegImage').remove();
			// snapSvgElement.selectAll('#backImage').remove();
			// snapSvgElement.selectAll('#frontLogo').remove();
			if (frontLogo == 'frontLogo' || frontLogo1 == 'frontLogo') {
			}else{
				this.availableLogoLocations.forEach(function (d) {
					if ((d.id != 'Chest-Logo' && d.id!='_x33_D_Soccer_Jersey_Layout') && document.getElementById(d.id) && d.id!='Bat-Image'){ 
						document.getElementById(d.id).setAttribute("data", "");
					d.selected = false;
					}
				});
			}
			if (frontLogo == 'frontLogo')
				document.getElementById('Chest-Logo').removeAttribute('data');
		} else {
			var object = this.sendcanvas.getActiveObject();

			if (object && !object.text) {
				this.sendcanvas.remove(object);
				this.base64textString = 'data:image/png;base64,' + this.defaultLogoBase64;
				this.hideLogoButtons = false;
			} else {
				var objs = this.sendcanvas.getObjects();
				var count = objs.length;
				for (var i = count - 1; i > 0; i--) {
					if (!objs[0].text)
						if (objs[i]._originalElement.className === "canvas-img")
							this.sendcanvas.remove(objs[i]);
				}
				this.base64textString = 'data:image/png;base64,' + this.defaultLogoBase64;
			}
		}


		const skuId = window.location.href.split('/design/')[1];
		const design_id = window.location.href.split('/submissions/')[1];

		if ((this.uploadedLogoPath || this.frontLogo) && !skuId && !design_id) {
			this.removeLogoFromDB(frontLogo, frontLogo1)

		}



	}

	async removeLogoFromDB(frontLogo, frontLogo1) {
		let storageRef = firebase.storage().ref();
		let uniqlogo = new Date().getTime();
		let removeName;
		if (frontLogo == 'frontLogo' || frontLogo1 == 'frontLogo') {
			removeName = this.uploadedlogoNameFront;
		} else {
			removeName = this.uploadedlogoName;

		}
		const fileData = await storageRef.child(`${'/uploaded-logos'}/${removeName}`).delete()
			.then(snapshot => {
				if (frontLogo == 'frontLogo' || frontLogo1 == 'frontLogo') {
					this.frontLogo = undefined;
				} else {
					this.uploadedLogoPath = undefined;
				}
			}).catch(error => {
			});
	}

	//Check Front numbers and Back Numbers are Available. If not Dispaly numbers on click of 3 In and 4 In buttons
	check_Display_Front_Numbers() {
			var object = this.getItemById('Number-Front');
			var object1 = this.getItemById('Front-Number-2');

		if (object == null || object1 == null) {
			object = {
				paths: document.getElementsByTagName("path")
			};
			object1 = {
				paths: document.getElementsByTagName("path")
			};
			
			if (object.paths) {
				for (var i = 0; i < object.paths.length; i++) {
					if (object.paths[i].id === "Number-Front") {
						if (object.paths[i].text === "") {
							this.updateTeamName.emit(new TexttoCanvasObj('FrontNumber', 'Text', '30'));
							break
						}
					}
				}
			}
			if (object1.paths) {
				for (var i = 0; i < object1.paths.length; i++) {
					if (object1.paths[i].id === "Front-Number-2") {
						if (object1.paths[i].text === "") {
							this.updateTeamName.emit(new TexttoCanvasObj('FrontNumber', 'Text', '30'));
							break
						}
					}
				}
			}

			
		} else {
			if (object.text === "") {
				this.updateTeamName.emit(new TexttoCanvasObj('FrontNumber', 'Text', '30'));
			}
			if (object1.text === "") {
				this.updateTeamName.emit(new TexttoCanvasObj('FrontNumber', 'Text', '30'));
			}
		}

	}

	//Check Front numbers and Back Numbers are Available. If not Dispaly numbers on click of 3 In and 4 In buttons
	check_Display_Back_Numbers() {
		var object = this.getItemById('Number-Back');
		if (object == null) {
			object = {
				paths: document.getElementsByTagName("path")
			};
			if (object.paths) {
				for (var i = 0; i < object.paths.length; i++) {
					if (object.paths[i].id === "Number-Back") {
						if (object.paths[i].text === "") {
							this.updateTeamName.emit(new TexttoCanvasObj('BackNumber', 'Text', '30'));
							break;
						}
					}
				}
			}
		} else {
			if (object.text === "") {
				this.updateTeamName.emit(new TexttoCanvasObj('BackNumber', 'Text', '30'));
			}
		}

	}
 

	changeFontSizeTeamName(font_Size){
		this.teamName.font_Size = font_Size;
		this.onChangeTeamNameValues(this.Team_Font_Size, 'Fontsize', 'Team');
	}
	changeFontSizePlayerName(font_Size){
		this.playerName.font_Size = font_Size;
		this.onChangeTeamNameValues(this.Player_Font_Size, 'Fontsize', 'Player');
	}

	// Used to Increment Decrement Font Size of Team and Palyer Names
	incrementDecrement_Team_Player_FontSize(type: string, teamorplayer: string) {
		if (teamorplayer === "Player") {
			if (type === "Incr")
				this.Player_Font_Size++;
			else if (type === "Decr" && this.Player_Font_Size > 7)
				this.Player_Font_Size--;

			this.playerName.font_Size = this.Player_Font_Size;

			this.onChangeTeamNameValues(this.Player_Font_Size, 'Fontsize', 'Player');
		} else if (teamorplayer === "Team") {
			if (type === "Incr")
				this.Team_Font_Size++;
			else if (type === "Decr" && this.Team_Font_Size > 7)
				this.Team_Font_Size--;
			this.teamName.font_Size = this.Team_Font_Size;
			this.onChangeTeamNameValues(this.Team_Font_Size, 'Fontsize', 'Team');
		} else if (teamorplayer === "FrontNumber") {
			if (type === "Incr")
				this.Front_Number_var++;
			else if (type === "Decr" && this.Front_Number_var > 7)
				this.Front_Number_var--;
			// Front_Number_var =
			this.onChangeTeamNameValues(this.Front_Number_var, 'Text', 'FrontNumber');
		}



	}




	//Initate Event emitter to apply selected color, font style and size to Canvas
	onChangeTeamNameValues(value: any, field: string, teamorplayer: string) {
		
		if (field === "Color") {
			if (teamorplayer === "FrontNumber" || teamorplayer === "BackNumber" || teamorplayer === "Numbers") {
				this.colorselectedforPlayerNumber = value;
				this.colorselectedforPlayerNumberName = value.colorName;
				this.frontNumber.colorCode = value.colorCode;
				this.backNumber.colorCode = value.colorCode;
				this.select_Number_background_color = value.colorCode;
			} else if (teamorplayer === "Player") {
				this.colornamePlayerselected = value.colorName
				this.colorselected1 = value;
				this.playerName.colorCode = this.select_Player_background_color = value.colorCode;
			}
			else if (teamorplayer === "Team") {
				this.colornameTeamselected = value.colorName;
			    this.colorselected = value;
				this.select_Team_background_color = this.teamName.colorCode = value.colorCode;
				let color = this.colorsList.find(element => element.colorCode == this.select_Team_background_color);
				if (color) {
					// this.selectedColor1 = color.colorName;
					// this.selectColorCode1 = color.colorCode;
					// this.playerName.colorCode = this.select_Player_background_color = color.colorCode;
					// for number
					// this.selectedColor2 = color.colorName;
					// this.selectColorCode2 = color.colorCode;
					// this.frontNumber.colorCode = color.colorCode;
					// this.backNumber.colorCode = color.colorCode;
					// this.select_Number_background_color = color.colorCode;
					// localStorage.setItem('emitcolor', 'emitcolor');
				}
			}
		} else if (field === "Fonttype") {
			if (teamorplayer === "Team")
				this.teamName.font_Type = this.select_Team_Font = value;
			else if (teamorplayer === "Player")
				this.playerName.font_Type = this.select_Player_Font = value;
			else if (teamorplayer === "FrontNumber" || teamorplayer === "BackNumber" || teamorplayer === "Numbers") {
				this.select_number_Font = value;
				this.frontNumber.font_Type;
				this.backNumber.font_Type;
			}
		} else if (field === "Name") {
			if (teamorplayer === "TeamBelow") {
				this.Team_Name_Below = value;
				if (value != '') {
					this.teamNameBelow.Name = value;
				}
			}
			else if (teamorplayer === "Team") {
				this.Team_Name = value;
				if (value != '') {
					this.teamName.Name = value;
					if (localStorage.getItem('curve')) {
						if (this.curveFlage) {
							if (this.circleType) {
								localStorage.removeItem('circleType');
							}
							this.curveFlageToInitiate = false;
							this.curveFlage = false;
							this.curveTitle = "add curve";
							this.showSlide1 = false;
						}

					}

				}

				localStorage.setItem('teamname', this.Team_Name);
			}
			else if (teamorplayer === "Player") {
				if (value != '') {
					this.playerName.Name = value;
					if (localStorage.getItem('curve')) {
						if (this.curveFlage1) {
							if (this.circleType1) {
								this.circleType1.destroy();
								localStorage.removeItem('circleType1');
							}
							this.curveFlageToInitiateback = false;
							this.curveFlage1 = false;
							this.curveTitleback = "add curve";
							this.showSlide2 = false;

						}
					}
				}
				this.Player_Name = value;
				localStorage.setItem('playername', this.Player_Name);


			} else if (teamorplayer === "FrontNumber" || teamorplayer === "BackNumber" || teamorplayer === "Numbers") {

				if (teamorplayer === "FrontNumber") {
					this.Front_Number = value;
				}
				if (teamorplayer === "BackNumber") {
					this.Back_Number = value;
				}
				if (value != '') {
					this.select_number_font_name = value;
					this.frontNumber.Name = value;
					this.backNumber.Name = value;
				} else {
					this.select_number_font_name = "none";
					this.frontNumber.Name = "none";
					this.backNumber.Name = "none";
					value = "none";
				}
			}

		} else if (field === "FontStroke") {
			
			if (teamorplayer === "Team"){

				this.colorselectedTeamFontOutline = value;
				this.colornameFontOutlineselected = value.colorName
				this.teamName.font_stroke = value.colorCode;
			}else if (teamorplayer === "Player"){
				this.colorselectedTeamFontOutline1 = value;
				this.colornameFontOutlineselected1 = value.colorName
				this.playerName.font_stroke = value.colorCode;
			}else if (teamorplayer === "FrontNumber" || teamorplayer === "BackNumber" || teamorplayer === "Numbers") {
				this.colorselectedfontOutlinePlayerNumber = value;
	            this.colorselectedfontOutlinePlayerNumberName = value.colorName;
				this.select_number_FontStroke = value.colorCode;
				this.frontNumber.font_stroke = value.colorCode;
				this.backNumber.font_stroke = value.colorCode;
			}
		} else if (field === "Fontsize") {
			// setTimeout(() => {
			if (teamorplayer === "Team") {
				let demodiv = <any>document.getElementById('Name-Front');
				// demodiv.style.display = "none";
				this.teamName.font_Size = value;
				// setTimeout(() => {
				// 	demodiv.style.display = "";
				// }, 1000);

			}
			else if (teamorplayer === "Player") {
				let demodiv1 = <any>document.getElementById('Name-Back');
				// demodiv1.style.display = "none";

				this.playerName.font_Size = value;
				// setTimeout(() => {
				// 	demodiv1.style.display = "";
				// }, 1000);

			}
			else if (teamorplayer === "FrontNumber" || teamorplayer === "BackNumber" || teamorplayer === "Numbers") {
				this.select_number_font_size = value;
				this.frontNumber.font_Size = value;
				this.backNumber.font_Size = value;
			}



		}
		if (teamorplayer === "Image") {
			this.updateTeamName.emit(new TexttoCanvasObj("Image", field, value)); //Event Emitter
		}
		if (!this.move_Rotate_TeamName && teamorplayer === "TeamBelow") {
			this.updateTeamNameBelow.emit(new TexttoCanvasObj("TeamBelow", field, this.Team_Name_Below)); //Event Emitter
		}
		else if (!this.move_Rotate_TeamName && teamorplayer === "Team") {
			this.updateTeamName.emit(new TexttoCanvasObj("Team", field, value));
			let t = this.Team_Name_Below;
			if (field == "Name")
				value = this.Team_Name_Below;
			this.updateTeamNameBelow.emit(new TexttoCanvasObj("TeamBelow", field, value)); //Event Emitter

			if (localStorage.getItem('emitcolor')) {
				if (field == 'Color') {
					this.updateTeamName.emit(new TexttoCanvasObj("Player", field, value));
					this.updateTeamName.emit(new TexttoCanvasObj("Numbers", field, value));
				}
			}
		}
		if (!this.move_Rotate_PlayerName && teamorplayer === "PlayerBelow") {
			this.updateTeamNameBelow.emit(new TexttoCanvasObj("PlayerBelow", field, value)); //Event Emitter
		}

		else if (!this.move_Rotate_PlayerName && teamorplayer === "Player") {
			this.updateTeamName.emit(new TexttoCanvasObj("Player", field, value));
			if (field == "Name")
				value = this.Player_Name_Below;
			this.updateTeamNameBelow.emit(new TexttoCanvasObj("PlayerBelow", field, value)); //Event Emitter
		} else if ((teamorplayer === "FrontNumber" || teamorplayer === "BackNumber" || teamorplayer === "Numbers") && !this.move_Rotate_PlayerName) {
			this.updateTeamName.emit(new TexttoCanvasObj(teamorplayer, field, value));
		}

	}

	textStyle(text){
		if(text == 'Arc Text'){
			this.showSlide1 = true;
			this.fontStyle = text;
			let visible = document.getElementById('Number-Front-p');
			if(visible){
				visible.style.display = "block";
				document.getElementById('Name-Front-p').setAttribute('height','20px');
			}else{
				document.getElementById('Name-Front-p').setAttribute('height','50px');
			}
			document.getElementById('Name-Front').style.margin = "";
			document.getElementById('Name-Front').style.width = "";
			document.getElementById('Name-Front').style.wordWrap = "";
			this.changeSlideValue(undefined);
		}else if (text == 'Vertical Text'){
			this.showSlide1 = false;
			if (this.circleType)
				this.circleType.destroy();
			localStorage.removeItem('circleType');
			this.curveFlageToInitiate = false;
			this.fontStyle = text;
			let visible = document.getElementById('Number-Front-p');
			if(visible){
				visible.style.display = "none";
				document.getElementById('Name-Front-p').setAttribute('height','20px');
			}else{
				document.getElementById('Name-Front-p').setAttribute('height','50px');
			}
			document.getElementById('Name-Front-p').setAttribute('height','150px');
			document.getElementById('Name-Front').style.margin = "0 auto 2em";
			document.getElementById('Name-Front').style.width = "0";
			document.getElementById('Name-Front').style.wordWrap = "break-word";

		}else if(text == 'Straight Text'){
			this.showSlide1 = false;
			if (this.circleType)
				this.circleType.destroy();
			localStorage.removeItem('circleType');
			this.curveFlageToInitiate = false;
			this.fontStyle = text;
			let visible = document.getElementById('Number-Front-p');
			if(visible){
				visible.style.display = "block";
				document.getElementById('Name-Front-p').setAttribute('height','20px');
			}else{
				document.getElementById('Name-Front-p').setAttribute('height','50px');
			}
			document.getElementById('Name-Front-p').setAttribute('height','20px');
			document.getElementById('Name-Front').style.margin = "";
			document.getElementById('Name-Front').style.width = "";
			document.getElementById('Name-Front').style.wordWrap = "";
		}
	}
	textStylePlayerName(text){
		if(text == 'Arc Text'){
			
			this.showSlide2 = true;
			this.fontStyle1 = text;
			let visible = document.getElementById('Number-Back-p');
			if(visible){
				visible.style.display = "block";
				document.getElementById('Name-Back-p').setAttribute('height','20px');
			}else{
				document.getElementById('Name-Back-p').setAttribute('height','50px');
			}
			document.getElementById('Name-Back').style.margin = "";
			document.getElementById('Name-Back').style.width = "";
			document.getElementById('Name-Back').style.wordWrap = "";
			this.changeSlideValue(undefined);
		}else if (text == 'Vertical Text'){
			this.showSlide2 = false;
			if (this.circleType1)
				this.circleType1.destroy();
			localStorage.removeItem('circleType1');
			this.curveFlageToInitiateback = false;
			this.fontStyle1 = text;
			let visible = document.getElementById('Number-Back-p');
			if(visible){
				visible.style.display = "none";
				document.getElementById('Name-Back-p').setAttribute('height','150px');
			}else{
				document.getElementById('Name-Back-p').setAttribute('height','200px');
			}
			document.getElementById('Name-Back').style.margin = "0 auto 2em";
			document.getElementById('Name-Back').style.width = "0";
			document.getElementById('Name-Back').style.wordWrap = "break-word";

		}else if(text == 'Straight Text'){
			this.showSlide2 = false;
			if (this.circleType1)
				this.circleType1.destroy();
			localStorage.removeItem('circleType1');
			this.curveFlageToInitiateback = false;
			this.fontStyle1 = text;
			let visible = document.getElementById('Number-Back-p');
			if(visible){
				visible.style.display = "block";
				document.getElementById('Name-Back-p').setAttribute('height','20px');
			}else{
				document.getElementById('Name-Back-p').setAttribute('height','50px');
			}
			document.getElementById('Name-Back').style.margin = "";
			document.getElementById('Name-Back').style.width = "";
			document.getElementById('Name-Back').style.wordWrap = "";
		}
	}

    curveFlagg1(flag,key){
		if(flag){
			this.showFontOutLine = true;
			this.fontOutline = key;
			let id  = <any>document.getElementById('abc');
			id.value = key
			
		}else{
			this.showFontOutLine =false;
			this.fontOutline = key;
			let id  = <any>document.getElementById('abc');
			$("#Name-Front").css("-webkit-text-stroke","0px");
			id.value = key
		}

	}
	showFontOutline1(flag,key){
        if(flag){
			this.showFontOutLine1 = true;
			this.fontOutline1 = key;
			let id  = <any>document.getElementById('showOutline1');
			id.value = key
			
		}else{
			this.showFontOutLine1 =false;
			this.fontOutline1 = key;
			let id  = <any>document.getElementById('showOutline1');
			id.value = key
			$("#Name-Back").css("-webkit-text-stroke","0px");
			
		}
	}

	showFontOutlineForPlayerNum(flag,key){
        if(flag){
			this.showFontOutLineForPlayerNum = true;
			this.fontOutlineForPlayerNum = key;
			let id  = <any>document.getElementById('showOutlinePlayerNumber');
			id.value = key
			
		}else{
			this.showFontOutLineForPlayerNum =false;
			this.fontOutlineForPlayerNum = key;
			let id  = <any>document.getElementById('showOutlinePlayerNumber');
			id.value = key
			$("#Number-Front").css("-webkit-text-stroke","0px");
			$("#Number-Back").css("-webkit-text-stroke","0px");
		}
	}

	///new method for Color

	///
	curveFlag(flag) {

		// if(this.curveTitle !='add curve')
		// if (this.curveFlage == true && this.curveTitle == 'add curve') return;
		// if (flag == true)
		// 	this.curveFlage = true;
		// else
		// 	this.curveFlage = false;
		// this.curveFlage = !this.curveFlage;
		if (this.curveFlage){
			this.curveFlageToInitiate = false;
		}
		this.markItCurveFront(true);
		localStorage.setItem('typed', 'true');
		if (this.curveFlage) {
			this.showSlide1 = true;
			this.slidervalue1 = 65;
			localStorage.removeItem('slidervalue1');

		}
		else {
			this.slidervalue1 = 65;
			this.showSlide1 = false;
			localStorage.removeItem('slidervalue1');
		}

	}
	curveFlag1(flag) {
		let back = <any>document.getElementById('Name-Back');
		if (back && back.style && back.style.display == 'none') {
			localStorage.setItem('typed2', 'true');
			back.style.display == 'none';
			this.showSlide2 = false;
			//1
		} else{

			// if (flag == 'true')
			// 	this.curveFlage1 = true;
			// else
			// this.curveFlage1 = false;
			// this.curveFlage1 = !this.curveFlage1;
			if (this.curveFlage1)
				this.curveFlageToInitiateback = false;
			this.markItCurveBack(true);
			localStorage.setItem('typed2', 'true');
			if (this.curveFlage1) {
				this.showSlide2 = true;
				this.slidervalue2 = 65;
				localStorage.removeItem('slidervalue2');
			}
			else {
				this.showSlide2 = false;
				this.slidervalue2 = 65;
				localStorage.removeItem('slidervalue2');
			}
		}
	}





	markItCurveBack(value) {
		let demodiv1;
		let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		if (!this.curveFlageToInitiateback) {
			if (this.circleType1) {
				this.circleType1.destroy();
				localStorage.removeItem('circleType1');
			}

			if (value != 'value') {
				document.getElementById('Name-Back').innerHTML = this.Player_Name;
			}
			if (this.circleType1)
				this.circleType1.refresh();
			demodiv1 = <any>document.getElementById('Name-Back');
			// if (isSafari)
			// 	document.getElementById('Name-Back').style.position = "fixed";
			this.circleType1 = new CircleType(document.getElementById('Name-Back'));
			this.circleType1.refresh();
			localStorage.setItem('circleType1', this.circleType1);
			localStorage.setItem('curve', 'true');
			this.curveFlageToInitiateback = true;
			this.curveFlage1 = true;
		} else {
			this.curveFlage1 = false;
		}


		if (this.curveFlage1) {
			this.circleType1.forceHeight(true);
			this.circleType1.forceWidth(true);
			if (localStorage.getItem('slidervalue2'))
				this.slidervalue2 = +(localStorage.getItem('slidervalue2'));
			else
				this.slidervalue2 = 65;
			this.circleType1.radius(this.slidervalue2);
			this.curveTitleback = "remove curve";
			this.showSlide2 = true;
			let visible = document.getElementById('Name-Back-p');
			visible.style.overflow = "visible";
			demodiv1.style.display = "none";
			if (isSafari) {

				demodiv1.childNodes[0].style.marginTop = "-11px";
				let div = <any>demodiv1.childNodes[0].childNodes;
				div.forEach(element => {
					element.classList.add("postionFixed")
				});

			} else {
				demodiv1.childNodes[0].style.position = "";
				demodiv1.childNodes[0].style.marginTop = "-4px";
			}
			if (this.showMessageFlag) {
				demodiv1.style.display = "none";
				this.showSlide2 = false;
			} else {
				setTimeout(() => {
					demodiv1.style.display = "";
				}, 300);
			}
		}
		if (!this.curveFlage1) {
			// if (isSafari)
			// 	document.getElementById('Name-Back').style.position = "fixed";
			this.curveTitleback = "add curve";
			this.showSlide2 = false;
			if (this.Player_Name == "") return;
			if (this.circleType1)
				this.circleType1.destroy();
			localStorage.removeItem('circleType1');
			this.curveFlageToInitiateback = false;
		}
	}

	markItCurveFront(value) {
		let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		let demodiv = <any>document.getElementById('Name-Front');
		demodiv.innerHTML = "";
		if (!this.curveFlageToInitiate) {
			if (this.circleType) {
				localStorage.removeItem('circleType');
			}
			if (value != 'value') {
				document.getElementById('Name-Front').innerHTML = this.Team_Name;
			}

			// if (isSafari)
			// 	document.getElementById('Name-Front').style.position = "fixed";
			this.circleType = new CircleType(document.getElementById('Name-Front'));
			this.circleType.forceHeight(true);
			this.circleType.forceWidth(true);
			if (localStorage.getItem('slidervalue1'))
				this.slidervalue1 = +(localStorage.getItem('slidervalue1'));
			else
				this.slidervalue1 = 65;

			this.circleType.radius(this.slidervalue1);
			this.curveFlageToInitiate = true;
			this.curveFlage = true;
		} else {
			this.curveFlage = false;
		}

		if (this.curveFlage) {
			let visible = document.getElementById('Name-Front-p');
			visible.style.overflow = "visible";
			demodiv.style.display = "none";
			localStorage.setItem('circleType', this.circleType);
			localStorage.setItem('curve', 'true');
			this.curveTitle = "remove curve";
			this.showSlide1 = true;

			if (isSafari) {


				demodiv.childNodes[0].style.marginTop = "-9px";
				// demodiv.childNodes[0].style.marginLeft = "-3px";
				let div = <any>demodiv.childNodes[0].childNodes;
				div.forEach(element => {
					element.classList.add("postionFixed")
				});

			} else {
				demodiv.childNodes[0].style.position = "";
				demodiv.childNodes[0].style.marginTop = "-10px";
			}
			setTimeout(() => {
				demodiv.style.display = "";
			}, 300)
		}
		if (!this.curveFlage) {
			// if (isSafari)
			// 	document.getElementById('Name-Front').style.position = "";
			this.curveTitle = "add curve";
			this.showSlide2 = false;
			if (this.Team_Name == "") return;
			if (this.circleType)
				this.circleType.destroy();
			localStorage.removeItem('circleType');
			this.curveFlageToInitiate = false;
		}
	}
	setFlag() {
		localStorage.setItem('typed', 'true');
	}
	setFlag1() {
		localStorage.setItem('typed2', 'true');
	}

	changeSlideValue(value) {
		if (this.curveFlage) {
			this.curveFlageToInitiate = false;
			localStorage.setItem('slidervalue1', '' + this.slidervalue1);
			this.markItCurveFront(true);
		} else {
			this.slidervalue1 = 65;
			localStorage.removeItem('slidervalue1');

		}

	}
	changeSlide2Value(value) {
		if (this.curveFlage1) {
			this.curveFlageToInitiateback = false;
			localStorage.setItem('slidervalue2', '' + this.slidervalue2);
			this.markItCurveBack(true);
		} else {
			localStorage.removeItem('slidervalue2');
			this.slidervalue2 = 65;
		}

	}

	openModalClipArtModal(frontLogo) {
		this.openModal.emit({ colorListforLayer: this.colorsList, frontLogo: frontLogo });

	}


	bottomText() {
		this.enableBottomText = !this.enableBottomText;
		if (!this.enableBottomText)
			document.getElementById('Name-Below-Front').style.display = "none";
		else
			document.getElementById('Name-Below-Front').style.display = "";

	}

	playerBottomText() {
		// this.enablePlayerBottomText = !this.enablePlayerBottomText;
		// if (!this.enablePlayerBottomText)
		// 	document.getElementById('Name-Below-Back').style.display = "none";
		// else
		// 	document.getElementById('Name-Below-Back').style.display = "";

	}

	checkCondition(id) {
		if (document.getElementById(id) && document.getElementById(id).style.display == "none")
			this.enablePlayerBottomText = false;
		else
			this.enablePlayerBottomText = true;
		return this.enablePlayerBottomText;
	}

	checkNameCondition(id) {
		if (document.getElementById(id) && document.getElementById(id).style.display == "none")
			this.enableBottomText = false;
		else
			this.enableBottomText = true;
		return this.enableBottomText;
	}

	checkElement(id) {
		if (document.getElementById(id))
			return true;
		return false;
	}

	checkCategory() {
		if (localStorage.getItem('category') == 'Football')
			return true;
		return false;

	}

	makeFrontNumberVisible() {
		this.onChangeTeamNameValues(this.Front_Number, 'Name', 'FrontNumber');
	}
	makeBackNumberVisible() {
		this.onChangeTeamNameValues(this.Back_Number, 'Name', 'BackNumber')
	}


	addLogo(removehref) {
		var abc = null;
		this.toDataURL(this.frontLogo, function(dataUrl) {
			abc = dataUrl;
		});
		if (document.getElementById('Chest-Logo')) {
			if (this.frontLogo != 'data:image/png;base64,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' && this.frontLogo!=undefined) {
				// if (this.frontLogo) {
				document.getElementById('Chest-Logo').setAttribute('height', '100');
				setTimeout(() => {
				// this.toDataURL(this.frontLogo, function(dataUrl) {
					document.getElementById('Chest-Logo').setAttribute("data", abc);
				// });
				document.getElementById('Chest-Logo').style.display = "block";
				document.getElementById('Front-Number-2').style.display = "block";
				document.getElementById('Name-Front-p').style.display = "none";
				document.getElementById('Number-Front-p').style.display = "none";
				}, 1000);
				
				// if (removehref == 'removehref') {
				// 	document.getElementById('Chest-Logo').removeAttribute('href');
				// }
			}
			// if (removehref == 'removehref') {
			// 	document.getElementById('Chest-Logo').removeAttribute('href');
			// }
		}

	

	}

	removeNameLogo() {
		document.getElementById('Chest-Logo').style.display = "none";
		document.getElementById('Front-Number-2').style.display = "none";
		document.getElementById('Name-Front-p').style.display = "block";
		document.getElementById('Number-Front-p').style.display = "block";
	}

	changeHeigth1Size(value) {
		let val = 50 + value;
		document.getElementById('Chest-Logo').setAttribute('height', val);
	}
	changeLogoSize(location,i,value){
			if(value!==NaN && value!==undefined && value!=='NaN' && value!=='undefined' && !isNaN(value) && value!==null && value!=='null'){
				document.getElementById(location).setAttribute("height", value );
				document.getElementById(location).setAttribute("width", value );
				//
				var x = document.getElementById(location + '-p').getAttribute("prevx");
				var y = document.getElementById(location + '-p').getAttribute("prevy");
				
				var height = document.getElementById(location + '-p').getAttribute("prevheight");
				var width = document.getElementById(location + '-p').getAttribute("prevwidth");
				
				document.getElementById(location + '-p').setAttribute("height", value );
				document.getElementById(location + '-p').setAttribute("width", value );
				// console.log("x, y",x, y);
				// console.log("height, width",height, width);
				if(value > width){
					var w = (parseInt(value) - parseInt(width))/2;
					var newX = parseInt(x) - w;
					console.log()
					document.getElementById(location + '-p').setAttribute("x", newX.toString());
				}else{
					document.getElementById(location + '-p').setAttribute("x", x);
					document.getElementById(location + '-p').setAttribute("height", height );
					document.getElementById(location + '-p').setAttribute("width", width );
				}
				if(value > height){
					var h = (parseInt(value) - parseInt(height))/2;
					var newY = parseInt(y) - h;
					console.log()
					document.getElementById(location + '-p').setAttribute("y", newY.toString());
				}else{
					document.getElementById(location + '-p').setAttribute("y", y);
				}
				
			}
	}

	checkLogoOrName() {
		if (document.getElementById('Name-Front-p').style.display == "none") {
			return true;
		}
		return false;

	}
}
